import script from "./TokenAmounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenAmounts.vue?vue&type=script&setup=true&lang=ts"

import "./TokenAmounts.vue?vue&type=style&index=0&id=251fba3a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251fba3a"]])

export default __exports__